export const buildStagePayload = ({
  companyId,
  changeType,
  staticDataKey,
  data,
  title,
  prNumbers,
  githubLink,
  reason,
}) => ({
  companyId,
  changeType: changeType ?? "config",
  key: staticDataKey,
  data,
  title: title.trim(),
  prNumbers,
  githubLink: githubLink?.trim() ? githubLink.trim() : undefined,
  reason: reason.trim(),
});

export const stagingErrorMessage = (error) =>
  error?.data?.message ||
  error?.error ||
  error?.message ||
  "Failed to stage config change";
